import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Container,
  Drawer,
  Grid,
  IconButton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTable from "../../../../components/CustomTable";
import CustomTextField from "../../../../components/CustomTextField";
import TopBar from "../../../../components/TopBar/TopBar";
import {
  createDepartment,
  deleteDepartment,
  getDepartmentList,
  updateDepartment,
} from "../../../../redux/reducers/departmentSlice";
import { AppColors } from "../../../../util/AppColors";

const tblHdrs = [
  "sNo",
  "departmentName",
  "createdBy",
  "createdDate",
  "actions",
];

function Department() {
  const dispatch = useDispatch();

  const [search, setSearch] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [form, setForm] = useState({ roleName: "" });
  const [delModVisible, setDelModVisible] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  const departmentList = useSelector((state) => state.department.list);

  useEffect(() => {
    dispatch(getDepartmentList());
  }, [dispatch]);

  const handleDrawerOpen = () => setOpenDrawer(true);

  const handleDrawerClose = () => {
    setOpenDrawer(false);
    setForm({ roleName: "" });
    setEditIndex(null);
  };

  const handleAddOrUpdate = () => {
    const action =
      editIndex !== null
        ? updateDepartment({
            roleId: departmentList[editIndex].roleId,
            roleName: form.roleName,
          })
        : createDepartment(form);

    dispatch(action).then(() => {
      dispatch(getDepartmentList());
      handleDrawerClose();
    });
  };

  const handleEdit = (index) => {
    const dept = departmentList[index];
    setForm({ roleName: dept.roleName });
    setEditIndex(index);
    setOpenDrawer(true);
  };

  const handleDeleteIconClick = (index) => {
    setDeleteIndex(index);
    setDelModVisible(true);
  };

  const handleDelModClose = () => {
    setDelModVisible(false);
    setDeleteIndex(null);
  };

  const handleDelConfirm = () => {
    const dept = departmentList[deleteIndex];
    dispatch(deleteDepartment({ roleId: dept.roleId })).then(() => {
      dispatch(getDepartmentList());
      handleDelModClose();
    });
  };

  const filteredRows = departmentList.filter((row) =>
    row.roleName.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Box>
      {/* Top Bar */}
      <TopBar>
        <Container maxWidth="xl">
          <Toolbar variant="regular">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row">
                <div className="top-row-cen-con w100Per">
                  {/* <Grid item xs={12} sm={12} md={5} lg={5} xl={5}> */}
                  <div className="w30Per">
                    {/* <CustomTextField
                      placeholder="Search"
                      name="name"
                      fullWidth
                      handleChange={(e) => setSearchValue(e.target.value)}
                      value={searchValue}
                      backgroundColor={AppColors.lightBlue2}
                    /> */}
                    <CustomTextField
                      placeholder="Search"
                      name="name"
                      fullWidth
                      handleChange={(e) => setSearch(e.target.value)}
                      value={search}
                      backgroundColor={AppColors.lightBlue2}
                    />
                  </div>
                  {/* </Grid> */}
                  {/* <Grid
                        item
                        xs={4}
                        sm={2}
                        md={2}
                        lg={1}
                        xl={1}
                        className="ml20"
                      > */}
                  <div className="ml20">
                    <CustomButton text="Create" onClick={handleDrawerOpen} />
                  </div>

                  {/* </Grid> */}
                  {/* <div className="top-row-right-con w15Per topBar-select">
                        <Select
                          list={filterList}
                          value={vetFilter}
                          handleChange={(e) => {
                            setVetFilter(e?.target?.value);
                            dispatch(
                              getClinicVets(`?type=${e?.target?.value}`)
                            );
                          }}
                          name="vet"
                          select
                        />
                      </div> */}
                </div>
              </div>
            </Grid>
          </Toolbar>
        </Container>
        <Typography className="font-medium fs12 gray28 ph20">
          Total Departments: {filteredRows.length}
        </Typography>
      </TopBar>
      {/* <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
      >
        <Box display="flex" gap={2} mx="auto" mb={2}>
          <TextField
            label="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            variant="outlined"
            size="small"
            sx={{ width: "500px", backgroundColor: AppColors.lightPink }}
          />
          <Button variant="contained" onClick={handleDrawerOpen}>
            Create
          </Button>
        </Box>
        <Typography variant="h6" sx={{ ml: "auto" }}>
          Total Departments: {filteredRows.length}
        </Typography>
      </Box> */}

      {/* Scrollable Table */}
      <Box>
        <CustomTable
          columns={tblHdrs}
          grey
          datas={filteredRows?.map((li, i) => ({
            sNo: i + 1,
            departmentName: li?.roleName,
            createdBy: li?.userName,
            createdDate: new Date(li?.createdDate).toLocaleDateString(),
            actions: (
              <div>
                <IconButton
                  color="primary"
                  size="small"
                  onClick={() => handleEdit(i)}
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  color="error"
                  size="small"
                  onClick={() => handleDeleteIconClick(i)}
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            ),
          }))}
        />
        {/* <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>Department Name</TableCell>
                <TableCell>Created By</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              ) : (
                filteredRows.map((row, index) => (
                  <TableRow key={row.roleId}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.roleName}</TableCell>
                    <TableCell>{row.userName || "-"}</TableCell>
                    <TableCell>
                      {new Date(row.createdDate).toLocaleDateString()}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => handleEdit(index)}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        color="error"
                        size="small"
                        onClick={() => handleDeleteIconClick(index)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer> */}
      </Box>

      {/* Drawer for Create & Edit */}
      <Drawer anchor="right" open={openDrawer} onClose={handleDrawerClose}>
        <Box p={3} width={300}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" color="primary">
              {editIndex !== null ? "Edit Department" : "Create Department"}
            </Typography>
            <IconButton onClick={handleDrawerClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>

          <TextField
            fullWidth
            label="Department Name"
            value={form.roleName}
            onChange={(e) => setForm({ ...form, roleName: e.target.value })}
            margin="normal"
            InputLabelProps={{
              sx: {
                position: "absolute",
                top: "50%",
                left: "14px",
                transform: "translateY(-50%)",
                transition: "all 0.2s ease-out",
                "&.Mui-focused, &.MuiFormLabel-filled": {
                  top: "0px",
                  transform: "translateY(-50%) scale(0.75)",
                  transformOrigin: "top left",
                },
              },
            }}
          />

          <Button
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={handleAddOrUpdate}
          >
            {editIndex !== null ? "Update" : "Add"}
          </Button>
        </Box>
      </Drawer>

      {/* Custom Modal for Delete Confirmation */}
      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          Are you sure you want to delete this record?{" "}
        </Typography>
        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleDelModClose} />
          </div>
          <div className="ml10">
            <CustomButton redBtn text="Confirm" onClick={handleDelConfirm} />
          </div>
        </div>
      </CustomModal>
    </Box>
  );
}

export default Department;
